import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { PageTransition } from './PageTransition';
import { useNavigation } from '@/contexts/NavigationContext';

// Footer is never above the fold — lazy-load to keep it off the critical path
const FooterLazy = lazy(() => import('./Footer').then((m) => ({ default: m.Footer })));

export const Layout = () => {
  const { curtainState } = useNavigation();

  return (
    <div className="min-h-screen bg-white text-black font-sans selection:bg-brand selection:text-white">
      <PageTransition state={curtainState} />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Suspense fallback={null}>
        <FooterLazy />
      </Suspense>
    </div>
  );
};
